import axios from 'axios';
import Cookies from 'js-cookie';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    common: {
      'Content-Type': 'application/json'
    }
  }
});

axiosInstance.interceptors.request.use(
  config => {
    // Do something before request is sent
    const newConfig = { ...config };
    newConfig.headers.Authorization = `Bearer: ${Cookies.get('4boxes_token')}`;
    return newConfig;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

export const axiosS3Instance = axios.create({
  headers: {
    common: {
      'Content-Type': 'application/json',
      'X-Amz-Acl': 'bucket-owner-full-control'
    }
  }
});
